/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Kn_Not_ConfiguredInputs */

const cs_property_registry_kn_not_configured = /** @type {(inputs: Property_Registry_Kn_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katastr není napojený — požádejte správce o přístup ČÚZK.`)
};

const en_property_registry_kn_not_configured = /** @type {(inputs: Property_Registry_Kn_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadastre is not connected — ask your admin for ČÚZK access.`)
};

/**
* | output |
* | --- |
* | "Cadastre is not connected — ask your admin for ČÚZK access." |
*
* @param {Property_Registry_Kn_Not_ConfiguredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_kn_not_configured = /** @type {((inputs?: Property_Registry_Kn_Not_ConfiguredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Kn_Not_ConfiguredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_kn_not_configured(inputs)
	return cs_property_registry_kn_not_configured(inputs)
});